import { useFetch, Panel, Tag, PageHeader, Empty } from "@/components/Common";
import { fmtTime } from "@/lib/api";

const impactTone = { High: "down", Medium: "warn", Low: "muted", Holiday: "blue" };

function Calendar() {
  const { data } = useFetch("/calendar");
  return (
    <Panel title="Economic calendar · this week" testid="economic-calendar">
      {data?.length ? (
        <div className="max-h-[560px] overflow-auto">
          <table className="w-full text-sm"><thead><tr className="label text-left"><th className="py-2">Time</th><th>Ccy</th><th>Event</th><th>Impact</th><th>Fcst</th><th>Prev</th></tr></thead>
            <tbody>{data.map((e, i) => (
              <tr key={i} className={`border-t border-border/50 ${new Date(e.date) < new Date() ? "opacity-50" : ""}`}>
                <td className="py-1.5 font-mono text-xs">{fmtTime(e.date)}</td><td className="font-mono">{e.country}</td><td>{e.title}</td>
                <td><Tag tone={impactTone[e.impact] || "muted"}>{e.impact}</Tag></td><td className="num text-xs">{e.forecast}</td><td className="num text-xs">{e.previous}</td>
              </tr>))}</tbody></table>
        </div>
      ) : <Empty>Calendar unavailable</Empty>}
    </Panel>
  );
}

const Feed = ({ items, testid }) => (
  <div className="space-y-2" data-testid={testid}>
    {items.map((n, i) => (
      <a key={i} href={n.link} target="_blank" rel="noreferrer" className="block rounded border border-transparent p-2 transition-colors hover:border-border hover:bg-secondary/50">
        <div className="flex flex-wrap gap-2"><Tag>{n.source}</Tag>{n.published && <span className="font-mono text-[10px] text-muted-foreground">{n.published.slice(0, 22)}</span>}{n.instruments?.slice(0, 5).map((s) => <Tag key={s} tone="blue">{s}</Tag>)}</div>
        <div className="mt-1 text-sm">{n.title}</div>
      </a>
    ))}
  </div>
);

function Social() {
  const { data } = useFetch("/social");
  if (!data) return null;
  return (
    <div className="grid gap-4 xl:grid-cols-3">
      {Object.entries(data).map(([k, v]) => (
        <Panel key={k} title={k === "x" ? "X" : k} testid={`social-${k}`} right={<Tag tone={v.status === "ok" ? "up" : "warn"}>{v.status.replace("_", " ")}</Tag>}>
          {v.items.length ? <Feed items={v.items.slice(0, 10)} /> : <Empty>{v.status === "not_configured" ? "Add the API key in Credentials to enable this feed." : "No items available from this source right now."}</Empty>}
        </Panel>
      ))}
    </div>
  );
}

export default function NewsCalendar() {
  const { data: news } = useFetch("/news", [], 600000);
  const { data: official } = useFetch("/official", [], 900000);
  return (
    <div className="space-y-4">
      <PageHeader title="News & Calendar" sub="Financial headlines and high-impact events feeding the AI desks and the news-blackout risk rule" />
      <div className="grid gap-4 xl:grid-cols-[1.3fr_1fr]">
        <Calendar />
        <Panel title="Financial news">{news?.length ? <div className="max-h-[560px] overflow-auto"><Feed items={news} testid="news-feed" /></div> : <Empty>Loading news…</Empty>}</Panel>
      </div>
      <Panel title="Official central-bank releases" testid="official-releases">{official?.length ? <div className="max-h-[420px] overflow-auto"><Feed items={official} /></div> : <Empty>Loading official releases…</Empty>}</Panel>
      <Social />
    </div>
  );
}
